'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMhAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#064DAE" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 0V5.33333L0 20L28 0Z",
          fill: "#F18D36"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 10.6667V5.33333L0 20L28 10.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.45176 5.829L6 2.66667L5.54824 5.829L4.33333 4.44658L4.95708 6.29041L3.11325 5.66667L4.49566 6.88157L1.33333 7.33333L4.49566 7.78509L3.11325 9L4.95708 8.37625L4.33333 10.2201L5.54824 8.83767L6 12L6.45176 8.83767L7.66667 10.2201L7.04292 8.37625L8.88675 9L7.50434 7.78509L10.6667 7.33333L7.50434 6.88157L8.88675 5.66667L7.04292 6.29041L7.66667 4.44658L6.45176 5.829Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagMhAsset = forwardRef(FlagMhAsset);

export { VpFlagMhAsset as default };
